import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface DeactivatePriceListModalProps {
  opened: boolean;
  priceListName: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const DeactivatePriceListModal = ({
  opened,
  priceListName,
  onClose,
  onConfirm,
  loading,
  isPaused
}: DeactivatePriceListModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      isPaused={isPaused}
      danger
      title={t('priceLists.deactivateTitle')}
      message={t('priceLists.deactivateMessage', { name: priceListName })}
      confirmLabel={t('priceLists.deactivateConfirm')}
    />
  );
};
